export default __webpack_public_path__ + "static/media/NUJABES  - SNARE.4a7dc303.wav";